<template>
  <div>
    <h1 class="text-center p-3 m-3">
      No Internet Connection or Very Poor Network
    </h1>
    <div class="bc text-center p-3">
      <h3>
        Check your Internet connection, Click the back Button and try again.
      </h3>
      <h5>
        Or go back to the
        <router-link :to="{ name: 'landing' }">Home Page</router-link>
      </h5>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
